import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "works-filter text-center" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "container mb-60 mb-xs-40" }
const _hoisted_4 = ["onSubmit"]
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = {
  class: "btn btn-mod btn-small mx-1",
  type: "submit",
  title: "Start Search"
}
const _hoisted_7 = {
  key: 0,
  class: "text-center"
}

import { ref, watch } from 'vue'
import WithLoadingPromise from '@/js/components/loading/WithLoadingPromise.vue'
import useNOIRLabArchives from '@/js/composables/useNOIRLabArchives'
import { mediaApi } from '@/js/api'
import usePageNumberAndQuery from '@/js/composables/usePageNumberAndQuery'
import Pagination from '@/js/components/Pagination.vue'
import { AxiosResponse } from 'axios'
import { useWindowSize } from '@vueuse/core'
import { MediaApiMediaImagesListRequest, PaginatedImageItemList, ImageItem } from '@/js/api-client'
import { Writeable } from '@/js/types'

interface Props {
  programName: string
  imageFeedUrl: string
  imageTakenFeedUrl: string
}

interface Category {
  id: string
  name: string
  apiFunction: () => Promise<AxiosResponse<PaginatedImageItemList>>
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ImagesList',
  props: {
    programName: null,
    imageFeedUrl: null,
    imageTakenFeedUrl: null
  },
  setup(__props: any) {

const props = __props as {
  programName: string
  imageFeedUrl: string
  imageTakenFeedUrl: string
};



const PAGE_SIZE = 40

console.log(props.programName)
const CATEGORIES: Array<Category> =
  props.programName.toLowerCase() === 'kpno'
    ? [
        {
          id: 'OF_KPNO',
          name: props.programName ? props.programName : '',
          apiFunction: programImages,
        },
        {
          id: 'TAKEN_FROM_KPNO',
          name: window.gettext(`Taken from ${props.programName}`),
          apiFunction: async function () {
            const kpnoFacilities = [
              50, 78, 45, 41, 79, 46, 54, 81, 42, 51, 49, 60, 55, 52, 56, 47, 48, 53, 59, 58, 88, 83, 44, 43,
            ]
            const params: Writeable<MediaApiMediaImagesListRequest> = {
              page: page.value,
              pageSize: PAGE_SIZE,
              facility: kpnoFacilities,
              tiny: true,
            }
            if (query.value) params.search = query.value
            return mediaApi.mediaImagesList(params)
          },
        },
      ]
    : [
        {
          id: `OF_${props.programName}`,
          name: props.programName ? props.programName : '',
          apiFunction: programImages,
        },
      ]

async function programImages() {
  const params: Writeable<MediaApiMediaImagesListRequest> = {
    category: props.programName.toLowerCase(),
    page: page.value,
    pageSize: PAGE_SIZE,
    tiny: true,
  }
  if (query.value) params.search = query.value
  return mediaApi.mediaImagesList(params)
}

const element = ref<HTMLElement | undefined>()
const imagesListElement = ref<HTMLElement | undefined>()
const withLoadingPromise = ref<InstanceType<typeof WithLoadingPromise>>()
const images = ref<Array<ImageItem>>([])
const totalPages = ref<number>(1)
const loadingPage = ref<boolean>(false)

const { page, query } = usePageNumberAndQuery()
const currentCategory = ref<Category>(getInitialCategory())
const { getImageFormat } = useNOIRLabArchives()
const { width } = useWindowSize()

// NOTE: Do not watch for page change, it would case issues like loading the data twice, either use @updated:modelValue in the Pagination component
watch(currentCategory, categoryUpdated)
watch(width, setupJustifiedImages)

function getInitialCategory() {
  const urlParams = new URLSearchParams(window.location.search)
  const category = urlParams.get('category') || ''
  return CATEGORIES.find((c) => c.id === category) || CATEGORIES[0]
}

async function loadImages() {
  const { data } = await currentCategory.value.apiFunction()
  images.value = data.results || []
  totalPages.value = data.count ? Math.ceil(data.count / PAGE_SIZE) : 0
  setTimeout(() => {
    setupJustifiedImages()
  }, 100)
}

function categoryUpdated() {
  page.value = 1
  const newURL = new URL(window.location.href)
  newURL.searchParams.set('category', currentCategory.value.id)
  window.history.replaceState({}, document.title, newURL)
  reloadImages()
}

function reloadImages() {
  if (withLoadingPromise.value) {
    return withLoadingPromise.value.reload()
  }
}

function onSearch() {
  page.value = 1
  reloadImages()
}

async function pageUpdated() {
  loadingPage.value = true
  await reloadImages()
  if (element.value) {
    element.value.scrollIntoView()
  }
  loadingPage.value = false
}

function setupJustifiedImages() {
  if (imagesListElement.value) {
    window.$(imagesListElement.value).empty().justifiedImages(getJustifiedConfiguration(400, 600, 8))
  }
}

function getJustifiedConfiguration(rowHeight, maxRowHeight, margin) {
  return {
    images: images.value
      .filter((image) => image.width && image.height)
      .map((image) => {
        return {
          id: image.id,
          src: getImageFormat(image.id, 'thumb300y'),
          srcScreen: getImageFormat(image.id, 'screen'),
          src700: getImageFormat(image.id, 'thumb700x'),
          width: image.width,
          height: image.height,
          title: image.title,
          url: `/images/${image.id}`,
        }
      }),
    rowHeight: rowHeight,
    maxRowHeight: maxRowHeight,
    imageContainer: 'item',
    thumbnailPath: function (photo, width, height) {
      let purl = photo.src
      if (height > 1000 || width > 900) {
        purl = photo.srcScreen
      } else if (height > 400) {
        purl = photo.src700
      }
      return purl
    },
    getSize: function (photo) {
      return { width: photo.width, height: photo.height }
    },
    template: function (data) {
      return (
        `<a aria-label="${data.title}" href="${data.url}" class="item" style="height:${data.displayHeight}px;margin-right:${data.marginRight}px;">` +
        `   <img class="image-thumb" style="width:${data.displayWidth}px;height:${data.displayHeight}px;" src="${data.src}" alt="${data.title}" />` +
        `   <div class="title">${data.title}</div>` +
        `</a>`
      )
    },
    margin: margin,
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _mergeProps({
    ref_key: "element",
    ref: element
  }, _ctx.$attrs), [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(CATEGORIES), (category) => {
        return (_openBlock(), _createElementBlock("a", {
          href: "#",
          onClick: _withModifiers(($event: any) => (currentCategory.value = category), ["prevent"]),
          class: _normalizeClass(["filter", { active: currentCategory.value.id === category.id }]),
          role: "button",
          "aria-pressed": "true"
        }, _toDisplayString(category.name), 11 /* TEXT, CLASS, PROPS */, _hoisted_2))
      }), 256 /* UNKEYED_FRAGMENT */))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("form", {
        class: "form d-flex justify-content-between align-items-stretch",
        onSubmit: _withModifiers(onSearch, ["prevent"])
      }, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(query) ? (query).value = $event : null)),
          type: "text",
          class: "form-control search-field round w-full",
          placeholder: `${_ctx.window.gettext('Search')}...`
        }, null, 8 /* PROPS */, _hoisted_5), [
          [_vModelText, _unref(query)]
        ]),
        _createElementVNode("button", _hoisted_6, _toDisplayString(_ctx.window.gettext('Search')), 1 /* TEXT */)
      ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_4)
    ]),
    _createVNode(WithLoadingPromise, {
      ref_key: "withLoadingPromise",
      ref: withLoadingPromise,
      "async-function": loadImages,
      "show-loading": !loadingPage.value
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          ref_key: "imagesListElement",
          ref: imagesListElement,
          class: "image-list image-list-300"
        }, null, 512 /* NEED_PATCH */),
        (images.value.length === 0)
          ? (_openBlock(), _createElementBlock("h3", _hoisted_7, _toDisplayString(_ctx.window.gettext('There are no images')), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        _createVNode(Pagination, {
          modelValue: _unref(page),
          "onUpdate:modelValue": [
            _cache[1] || (_cache[1] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
            pageUpdated
          ],
          "total-pages": totalPages.value,
          loading: loadingPage.value
        }, null, 8 /* PROPS */, ["modelValue", "total-pages", "loading"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["show-loading"])
  ], 16 /* FULL_PROPS */))
}
}

})